import AOS from 'aos';
import 'owl.carousel';
import 'magnific-popup';
import 'select2';

import common from './modules/common';
import nav from './modules/nav';

import block_common from './modules/block_common';
import block_posts from './modules/block_posts';
import block_events from './modules/block_events';
import block_button from './modules/block_button';
import block_teams from './modules/block_teams';
import block_galleries from './modules/block_galleries';
import block_gallery from './modules/block_gallery';
import block_toys from './modules/block_toys';
import block_faq from './modules/block_faq';
import single_rider from './modules/single_rider';
import single_toy from './modules/single_toy';
import ticket from './modules/ticket';
import block_livetiming from './modules/block_livetiming';
import block_leaderboard from './modules/block_leaderboard';
import block_announcements from './modules/block_announcements';

jQuery( document ).ready(function($) {
  
  common();
  nav();

  // Blocks
  block_posts();
  block_events();
  block_button();
  block_teams();
  block_galleries();
  block_gallery();
  block_toys();
  block_faq();
  block_livetiming();
  block_leaderboard();
  block_announcements();

  // Single page
  single_rider();
  single_toy();

  ticket();

  //restricted blocks
  const currentLanguage = $('body').data('country')
  $('.restricted-block').each(function(){
    const restrictedTo = $(this).data('block-languages')
    if (!restrictedTo.includes(currentLanguage)) {
      $(this).hide()
    }
  })
  
  // AOS init
  AOS.init({
    duration: 1000,
    once: true
  });

  const swiperThumbs = new Swiper('.slider-fanfest-main-thumbs', {
    slidesPerView: 6,
    spaceBetween: 10,
    watchSlidesProgress: true,
  });

  const swiper = new Swiper('.slider-fanfest-main', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiperThumbs,
    },
  });


  // scroll to anchor
  const urlParams = new URLSearchParams(window.location.search);
  const anchor = urlParams.get('section');
  if (anchor) {
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

});
